import { getLangMap } from "@/utils/getLangMap.ts";
import "dayjs/locale/ru";
const RU_LANGS = new Set(["ru-ru"]);
const RU_LINKS = new Set(["ru-mils.comfortweather.com", "rs-miwg.comfortweather.com", "rs-mils.comfortweather.com"]);
export function isLongText() {
  const { subdomain } = useSubdomain();
  const curLan = getLangMap();

  if (curLan) return RU_LANGS.has(curLan);
  if (subdomain) return RU_LINKS.has(`${subdomain}.comfortweather.com`);
  return RU_LINKS.has(window.location.hostname);
}
